import React, { Component } from 'react'
import { Button, ResumeCard } from './style.style'

export class CardBoxButton extends Component {
	render() {
		const { desktop, allDevices, handleClick, title, text } = this.props
		let className = allDevices ? '-allDevices' : desktop ? '-desktop' : ''
		return (
			<ResumeCard className={className}>
				<Button
					type="button"
					onClick={e => {
						handleClick(e)
					}}
					title={title}>
					{text}
				</Button>
			</ResumeCard>
		)
	}
}
